import { css } from 'emotion';

export const refresh = css`
	cursor: pointer;
	float: right;
`;

export const viewLbl = css`
	border: none !important;
`;

export const recordsLbl = css`
	border: none !important;
	font-weight: normal !important;
`;

export const viewSelectorRow = css`
	padding: 10px 0 20px 0;
`;

export const tabsWrapper = css`
	display: flex;
	justify-content: space-between;
	padding-bottom: 40px;
`;

export const buttonsRow = css`
	padding-bottom: 20px;
`;

export const buttonsRowSpaced = css`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const footer = css`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-left: 10px;
`;

export const formGroup = css`
	flex-wrap: wrap;
	> div.field {
		padding-top: 0.5em;
		padding-bottom: 0.5em;
	}
`;

export const dbtn = css`
	margin-left: 2px !important;
`;

export const topBtnRow = css`
	margin-bottom: 15px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const modalCont = css`
	min-height: 400px !important;
`;

export const modalConfirmation = css`
	margin-top: auto !important;
	display: inline-block !important;
	position: relative;
	top: 35%;
`;



// WEBPACK FOOTER //
// ./src/routes/Viewer/styles.js